import React from "react"
import Container from "./IconContainer"


const CheckIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="13px"
      height="10px"
      viewBox="0 0 13 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="190701"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="2_NYT-Dashboard-D"
          transform="translate(-106.000000, -917.000000)"
          stroke="#505050"
          strokeWidth="1.5"
        >
          <g id="check-copy-11" transform="translate(107.000000, 918.000000)">
            <polyline
              id="Shape"
              points="11.1428571 0 3.48214286 7.66071429 0 4.17857143"
            />
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default CheckIcon



// WEBPACK FOOTER //
// ./assets/common/components/icons/CheckIcon.js